import { render, staticRenderFns } from "./InvestmentTestResult.vue?vue&type=template&id=263a224d&scoped=true&"
import script from "./InvestmentTestResult.vue?vue&type=script&lang=js&"
export * from "./InvestmentTestResult.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentTestResult.vue?vue&type=style&index=0&id=263a224d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a224d",
  null
  
)

export default component.exports